module.exports = __webpack_public_path__ + "static/media/edn-ending.609be457.mp3";